module.exports = __webpack_public_path__ + "static/media/2022_4G8A1137.0a031cf1.jpg";